import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { RealitySection } from './components/RealitySection';
import { OldSolutionsSection } from './components/OldSolutionsSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ForWhoSection } from './components/ForWhoSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { OfferSection } from './components/OfferSection';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <RealitySection data-id="element-3" />
      <OldSolutionsSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <WhatYouGetSection data-id="element-6" />
      <ForWhoSection data-id="element-7" />
      <ObjectionsSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <Footer data-id="element-10" />
      <FloatingCTA data-id="element-11" />

      {/* Bottom spacer for floating CTA on mobile */}
      <div className="h-16 md:h-0" data-id="element-12" />
    </div>;
}